import PATH from '../constants/routeConstants';
import {clearAllFilterModels} from './gridFilterSession';

/**
 * Error codes that mean the session is gone on the server and cannot be
 * recovered by retrying. The only way forward is a fresh sign in.
 *
 * Deliberately excluded:
 *  - CURRENT_USER_IS_BLOCKED, already handled by recordController and
 *    useGridViewState, which route to the /access_blocked page.
 *  - CURRENT_USER_IS_PENDING / _INACTIVE / _DISABLED. These arrive as 400 and
 *    the account is still authenticated. Signing out on PENDING in particular
 *    would break the completeOnboarding flow, where the user is legitimately
 *    pending while finishing signup.
 *  - UNAUTHORIZED_DATA_ACCESS and NOT_ALLOWED_WHILE_IMPERSONATING. These are
 *    401s, but the session is valid, the user just cannot reach that data.
 */
const SESSION_ENDED_CODES = [
  'EXPIRED_ACCESS_TOKEN',
  'INVALID_ACCESS_TOKEN',
  'INVALID_REFRESH_TOKEN',
  'LOGIN_REQUIRED',
];

// A dead session usually fails several in-flight requests at once, and each one
// would otherwise start its own redirect.
let redirecting = false;

const isSessionEnded = (errorCode)=> SESSION_ENDED_CODES.indexOf(errorCode) !== -1;

const endSession = ()=> {
  if(redirecting || window.location.pathname === PATH.LOGIN) {
    return;
  }
  redirecting = true;
  // Matches what the signOut reducer does on a normal sign out.
  localStorage.clear();
  clearAllFilterModels();
  window.location.assign(PATH.LOGIN);
};

const handleAuthFailure = (errorCode)=> {
  if(!isSessionEnded(errorCode)) {
    return false;
  }
  endSession();
  return true;
};

export {handleAuthFailure, isSessionEnded, SESSION_ENDED_CODES};
